import React from 'react';
import { ConfirmationModal } from '../../../lomavisCreator/components/confirmationModal';
import { useTranslate } from '@tolgee/react';

const DeleteConfirmationModal = ({ show, handleClose, handleDelete }) => {
  const { t } = useTranslate();
  return (
    <>
      <ConfirmationModal
        title={t('lomavisPostApproval.deleteGroupModal.title')}
        body={t('lomavisPostApproval.deleteGroupModal.body')}
        primaryText={t('lomavisPostApproval.deleteGroupModal.primaryText')}
        secondaryText={t('lomavisPostApproval.deleteGroupModal.secondaryText')}
        show={show}
        handleClose={() => {
          handleClose();
        }}
        handlePrimary={() => {
          handleDelete();
          handleClose();
        }}
        handleSecondary={() => {
          handleClose();
        }}
      />
    </>
  );
};

export default DeleteConfirmationModal;
